import { Container, Row, Col, TabContainer, TabContent, TabPane } from "react-bootstrap";

import projImg1 from '../assets/img/crud_2_img.png';
import projImg2 from '../assets/img/form_phpMailer3.png';
import projImg3 from '../assets/img/fast_laravel_crud4.png';
import projImg4 from '../assets/img/quilterrierApp.png';
import projImg5 from '../assets/img/poo_php.png';

import { ProjectCard } from './ProjectCard';

export const Projects = () => {
    const projects = [
        {
            title: "IMAGE CRUD SYSTEM",
            description: "PHP, MySQL, Bootstrap",
            imgUrl: projImg1,
            bigTitle: "Image Manager",
            repositoryLink: "https://github.com/nrubioh/php_exercises/blob/master/crud_2_img/read_CRUD_IMG.md",
        },
        {
            title: "FORM WITH MAILER",
            description: "PHP, PHPMailer, Bootstrap",
            imgUrl: projImg2,
            bigTitle: "FORM WITH MAILER",
            repositoryLink: "https://github.com/nrubioh/php_exercises/blob/master/form/read_FORM_PHPMAILER.md",
        },
        {
            title: "LARAVEL CRUD MANAGER",
            description: "LARAVEL, MySQL",
            imgUrl: projImg3,
            bigTitle: "LARAVEL CRUD MANAGER",
            repositoryLink: "https://github.com/nrubioh/laragon-fastcrud",
        },
        {
            title: "QUILTERRIER APP",
            description: "JAVA & ANDROID STUDIO",
            imgUrl: projImg4,
            bigTitle: "QUILTERRIER APP",
            repositoryLink: "https://github.com/nrubioh/quilterrierApp?tab=readme-ov-file",
        },
        {
            title: "OOP PRACTICE GAME PHP",
            description: "PHP",
            imgUrl: projImg5,
            bigTitle: "OOP PRACTICE GAME PHP",
            repositoryLink: "https://github.com/nrubioh/php_exercises/tree/master/POO_exercises/POO5",
        },
    ];
    return (
        <section className="project">
            <Container>
                <Row>
                    <Col id="projects">
                        <h2>Tech Projects</h2>
                        <TabContainer id="projects-tabs" defaultActiveKey="first">
                                                    
                            {/* <Nav variant="pills">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Projects</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Experience</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third">Reviews</Nav.Link>
                                </Nav.Item>
                            </Nav> */}

                            <TabContent>
                                <TabPane eventKey="first">
                                    <Row>
                                        {
                                            projects.map( (project, index) =>{
                                                return(
                                                    <ProjectCard 
                                                        key={index}
                                                        {...project}
                                                    />
                                                );
                                            } )
                                        }
                                    </Row>
                                </TabPane>
                                {/* <TabPane eventKey="second">
                                    <Row>
                                        
                                    </Row>
                                </TabPane>
                                <TabPane eventKey="third">
                                    Lorem Ipsum
                                </TabPane> */}
                            </TabContent>
                        </TabContainer>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}